<template>
    <div class="scanPreResult" v-loading="loading">
        <el-row>
            <div class="search_container searchArea">
                <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                    <!-- <el-form-item label="班级"  prop="hardId" v-if="userInfo.role=='teacher'">
                        <el-select v-model="searchForm.hardId" filterable placeholder="请选择" @change="hardChange">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for="item in hardClassList" :key="item.id" :label="item.name+'('+item.year+')'" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="学年学期" >
                        <el-select v-model="searchFormRole.semester" filterable placeholder="请选择" style="width: 100%" @change="filterExam">
                            <el-option :key="null" label="全部" :value="null"></el-option>
                            <el-option v-for="item in acadyearTermList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="二级单位:" prop="schoolId" v-if="userInfo.role != 'teacher'" >
                        <el-select v-model="searchFormRole.schoolId" filterable placeholder="请选择" @change="filterExam">
                            <el-option :key="null" label="全部" :value="null"></el-option>
                            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    
                    <el-form-item label="课程:" prop="courseId" v-if="userInfo.role == 'teacher'" >
                        <el-select v-model="searchFormRole.courseId" filterable placeholder="请选择" @change="filterExam">
                            <el-option :key="null" label="全部" :value="null"></el-option>
                            <el-option v-for="item in courseList" :key="item.id" :label="item.courseName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="考试号/名称:" prop="examId" >
                        <el-select v-model="searchForm.examId" filterable placeholder="请选择" remote :remote-method="remoteExam" @change="examChange" style="min-width: 300px;" >
                            <!--                        <el-option key="" label="全部" value=""></el-option>-->
                            <el-option v-for="item in examList" :key="item.id" :label="item.name+'('+(item.id||item.exam_id)+')'" :value="item.id||item.exam_id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="查找学生">
                        <el-input v-model="searchForm.searchText" placeholder="学号、姓名"  @keyup.enter.native='searchRightList'></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" size ="mini" icon="search" @click='searchRightList'>查询</el-button>
                    </el-form-item>
                    <el-form-item v-if="rightList && rightList.length > 0">
                        <!-- 人数：{{searchForm.totalCount}} -->
                        <el-button type="text" size="mini" @click="showExamInfo">入库人数：{{searchForm.totalCount}} </el-button>( 作弊/缺考：{{ specialNums }} ) 总数： {{  totalNums }}
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="filterScore" @change="scoreSearch" style="margin-right:5px"></el-checkbox>
                        <span v-show="!filterScore">成绩查询</span>
                        <el-button type="info" @click="scoreSearch" v-show="filterScore">成绩查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="filter" @change="filterStudents">仅缺考/作弊学生</el-checkbox>
                        ({{ specialNums }}人)
                    </el-form-item>
                </el-form>
            </div>
        </el-row>

        <el-row class="scan-card" >
            <el-col :span="4" >
        
                <div v-if="searchForm.examId != null && searchForm.examId != '' && searchForm.examId != undefined  && hardAndTeachingClassList.length > 0">
                  <!-- <el-select v-model="searchForm.examHardId" filterable placeholder="请选择" @change="searchRightList">
                    <el-option :key="null" label="全部" :value="null"></el-option>
                    <el-option v-for="item in examHardClassList" :key="item.hard_id" :label="item.hard_name+'('+item.cou+')'" :value="item.hard_id">
                    </el-option>
                  </el-select> -->

                  <el-select v-model="searchForm.hardClassId" filterable placeholder="请选择" :loading="selectIsLoading" @change="searchRightList">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option v-for="item in hardAndTeachingClassList" :key="item.id" :label="item.name" :value="item.id">
                        <span :style="{ color: item.classType === 'hardClass' ? '#303133' : '#67C23A' }">
                        {{ item.name }}
                        </span>
                    </el-option>
                   </el-select>
                </div>
                <div class="left-part" :style="leftStyle"  v-if="rightList && rightList.length > 0">
                    <el-row class="data-row"  v-for="(item, index) in rightList">
                        <el-col :span="24"  class="student-no-lost">
                            <el-link type="primary" @click="openRight(item)">{{item.student_name}}({{item.student_no}})</el-link>
                        </el-col>
                    </el-row>
                    <el-row class="page-row">
                        <el-col :span="8">
                            <el-button type="text" size="mini" @click='loadByPage(-1)'>上一页</el-button>
                        </el-col>
                        <el-col :span="8">
                            {{searchForm.pageNo}}/{{parseInt(searchForm.totalCount/searchForm.pageSize)+1}}
                        </el-col>
                        <el-col :span="8">
                            <el-button type="text" size="mini" @click='loadByPage(1)'>下一页</el-button>
                        </el-col>
                    </el-row>
                </div>

            </el-col>
            <el-col :span="20" >
                <rightPage v-if="selRight!=null" ref="rightPage" :info="selRight" :filter="filter" :percentType="percentType" @ok="examChange" @changeExam="examChange"></rightPage>
            </el-col>
        </el-row>


        <!-- 成绩查询 -->
        <el-dialog title="成绩查询" :visible.sync="scoreSearchDialogVisible" width="30%" center :close-on-click-modal="false">
            <span style="margin-right: 20px"> 查询类型 </span>
            <el-select v-model="scoreForm.type" filterable placeholder="请选择" style="width: 120px;margin-right: 20px">
                <el-option v-for="item in scoreTypeList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
            </el-select>

            <!-- <span> 分数范围 </span> -->
            <el-input v-model="scoreForm.scoreFrom" autocomplete="off" style="width: 80px"></el-input>
                <span style="margin-left: 20px">至</span>
            <el-input v-model="scoreForm.scoreTo" autocomplete="off"  style="width: 80px;margin-left: 20px"></el-input>


            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="loading" @click="scoreSearchSubmit">确 定</el-button>
                <el-button @click="scoreSearchCancel">取 消</el-button>
            </div>
        </el-dialog>


    </div>

    
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import { saveAs } from 'file-saver';
    import * as simpleApi from "request/simple";
    import rightPage from "./rightPage"
    import XEUtils from "xe-utils";
    import Pagination from "@/components/pagination";

    export default {
        name: 'scanPreResult',
        data(){
            return {
                tableData: [], tableHeight:0, examList: [],
                loading:false, queryExamId: null, queryStudentNo: null,
                selRight: null, hardClassList: [], examHardClassList: [],
                rightList: [], leftStyle: null, examId: null,
                examForm: { id: null, searchText: null, },
                searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null, hardId: null, examId: null, examHardId: null,  },
                searchFormRole:{ 
                    semester: null,
                    courseId: null,
                    schoolId: null
                },
                // 学年学期
                acadyearTermList: [],
                // 课程
                courseList:[],
                // 二级单位
                schoolList: [],
                // 筛选缺考/作弊学生
                filter: false,
                specialNums: 0,
                // 行政班教学班混合
                hardAndTeachingClassList: [],
                selectIsLoading: false,
                // 成绩查询
                scoreSearchDialogVisible: false,
                scoreForm:{
                    type: 'total',
                    scoreFrom: 0,
                    scoreTo: 0
                },
                // 是否启动成绩查询
                filterScore: false,
                // 查询成绩类型
                scoreTypeList: [
                    { value: 'total',name: '总成绩'},
                    { value: 'kg',name: '客观题'},
                    { value: 'zg',name: '主观题'},
                ],
                // 总数
                totalNums: 0,
                // 客观题换算比例版本
                percentType: false

            }
        },
        components:{
            Pagination, rightPage,
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
        created() {
        },
      	mounted() {
            this.loadAcadyearTermList()
            this.loadCourseList()
            this.loadSchoolList()
            console.log("userInfo", this.userInfo)
            let myHeight = document.documentElement.clientHeight ;
            this.loadHMyClassSelectList();
            this.leftStyle = {height: (myHeight-250) + 'px'};
            let queryExamId = this.$route.query.e;
            if(queryExamId && queryExamId != null) this.queryExamId = XEUtils.toNumber(queryExamId); else this.queryExamId = null;
            let queryStudentNo = this.$route.query.sn;
            if(queryStudentNo && queryStudentNo != null) this.queryStudentNo = queryStudentNo; else this.queryStudentNo = null;
            let that = this;
            
            this.loadExamList(function () {
                if(that.queryExamId != null && that.queryStudentNo){
                    that.searchForm.pageNo = 1;
                    that.searchForm.examId = that.queryExamId; that.searchForm.searchText = that.queryStudentNo;
                    that.loadRightList(function (myList) {
                        if(myList && myList.length > 0){
                            that.openRight(myList[0]);
                        }
                    });
                }

            });
	   },
        methods: {

            formatStatus(status){
                return mUtils.examStatus(status);
            },
            getExamName(index, item){
                if(item.student_no != null){
                    return index + "." + item.student_no + "(" + item.seq + ")";
                }
                return index + "." + mUtils.strLeft(item.exam_name, 15) + "(" + item.seq + ")";
            },
            loadHMyClassSelectList(){

                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'teacherMyClass', methodName: '/myClassSelect',  param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (code == 0) {
                        this.hardClassList = data;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            examChange(v){
                this.loading = true;
                this.setSelNull();
                // 清空当前选中班级
                this.searchForm.hardClassId = ''
                // 获取行政班
                // this.loadExamHardList();
                // 获取行政班和教学班混合列表
                
                this.searchHardOrTeachingClass()
                this.loadRightList();
                this.searchRightList();
                this.filterStudents();
            },
            hardChange(v){
                if(v == "") this.loadExamList();
                else this.loadMyClassExams(v);
            },
            loadMyClassExams(hardId){
                this.examList = [];
                let param = { controllerName: 'teacherMyClass', methodName: '/myClassExams', pageNo: 1, pageSize: 5000, param: { hardClassId: hardId}};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (code == 0) {
                        this.examList = data;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            loadExamList(callback){
                let search = { licenceId: this.userInfo.licenceId, isAb: '1', schoolId: null, teacherId: null, searchText: mUtils.searchText(this.examForm.searchText)};
                let role = this.userInfo.role;
                if(role == "sclAdmin") search["schoolId"] = this.userInfo.schoolId;
                if(role == "teacher") {
                    // search["schoolId"] = this.userInfo.schoolId;
                    search["teacherId"] = this.userInfo.id;
                }
                let param = { controllerName: 'exam', methodName: '/examList', pageNo: 1, pageSize: 50, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.examList = data.result;
                        if(callback) callback(data.result);
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            remoteExam(query){
              if(query !== '' && query.length > 1){
                console.log("remoteExam", query);
                this.examForm.id = null;
                this.examForm.searchText = query;
                this.examList = [];
                this.loadExamList();
              }
            },
            openRight(row){
                this.selRight = row;
            },
            loadByPage(i){
                if(i<0 && this.searchForm.pageNo < 2) return;
                if(i>0 && this.searchForm.pageNo > parseInt(this.searchForm.totalCount/this.searchForm.pageSize)) return;
                this.searchForm.pageNo = this.searchForm.pageNo + i;
                this.loadRightList();
            },
            searchRightList(){
                this.searchForm.pageNo = 1;
                let that = this;
                let ar = XEUtils.find(this.examList, item => {
                    return item.id == that.searchForm.examId;
                });
                if(ar){
                    console.log('searchRightList', ar)
                    this.teacherName = ar.teacher_name;
                    this.nickName = ar.nick_name;
                    this.examName = ar.name;
                    this.licenceName = ar.licence_name
                    this.searchForm.licenceId = ar.licence_id;
                    // 判断是否勾选缺考/作弊
                    if(this.filter){
                        this.filterStudents()
                    }else{
                        this.loadRightList();
                    }
                    
                    this.loadCount()
                    this.getScantronInfo()
                }
                this.selRight = null;
            },

            loadExamHardList(){
              let search = { licenceId: this.userInfo.licenceId, examId: mUtils.searchText(this.searchForm.examId), orderBy: null};
              let param = { controllerName: 'exam/kg', methodName: '/hardClassList',  param: search};
              return simpleApi.post(param).then(({result: {code, data}}) =>  {
                console.log("loadRightList", data)
                if (code == 0) {
                  this.examHardClassList = data;
                }
              }).catch((error) => {
                console.log("error", error)
              });
            },
            loadRightList(callback){

                let search = { licenceId: this.userInfo.licenceId, examId: mUtils.searchText(this.searchForm.examId),
                    searchText: mUtils.searchText(this.searchForm.searchText),  orderBy: 'sf.student_no'};


                // 如果勾选成绩查询 就新增成绩范围的查询条件
                if(this.filterScore){
                    search.scoreType = this.scoreForm.type
                    search.scoreFrom = this.scoreForm.scoreFrom * 1
                    search.scoreTo = this.scoreForm.scoreTo * 1
                }
                
                if(this.searchForm.hardClassId != undefined && this.searchForm.hardClassId != ''){
                    // 判断选中的班级是行政班还是教学班
                    let classInfo  = this.hardAndTeachingClassList.find(item => item.id === this.searchForm.hardClassId)
                    if (!classInfo) return
                    if(classInfo.classType == 'hardClass'){
                        search.hardId =  mUtils.searchText(this.searchForm.hardClassId)
                        search.teachingClassId = null
                    }else{
                        search.teachingClassId =  mUtils.searchText(this.searchForm.hardClassId)
                        search.hardId = null
                    }
                }

                let param = { controllerName: 'scan/scanPreResult', methodName: '/list', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadRightList", data)
                    if (data.code == 0) {
                        this.rightList = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                        this.totalNums = data.totalCount + this.specialNums
                        // if(callback) callback(this.rightList);
                    }
                    this.loading = false;
                }).catch((error) => {
                    console.log("error", error)
                });
            },

            loadScanCount(){

                let search = { licenceId: this.userInfo.licenceId, examId: this.examId};
                let param = { controllerName: 'scan/scanPreResult', methodName: '/scanCount', param: search};
                return simpleApi.post(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data) {


                    }
                }).catch((error) => {
                    console.log("error")
                });
            },

            setSelNull(){
                this.selRight = null;
            },

            loadAcadyearTermList(){
                this.acadyearTermList = [];
                let now = new Date();
                let year = parseInt(now.getFullYear());

                for(let i=(year-3); i<(year+2); i++){
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第一学期');
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第二学期');
                }
            },
            loadCourseList(){

                let search = { licenceId: this.userInfo.licenceId,schoolId: this.userInfo.schoolId};
                // 判断登录用户是否是校级管理员
                if(this.userInfo.role == "sclAdmin") search['schoolId'] = this.userInfo.schoolId
                let param = { controllerName: 'sclCource', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        // 拼接课程名称和课程编号
                        let list =  data.result
                        list = list.map(item => ({
                            ...item,
                            courseName: item.name + '(' + item.course_no + ')'
                        }))
                        this.courseList = list;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            loadSchoolList(){
                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'school', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.schoolList = data.result;
                        if(this.userInfo.schoolId) this.searchForm.schoolId = this.userInfo.schoolId;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },

            // 根据条件过滤对应的考试列表
            filterExam(){
                // 更新考试列表 以及清空列表
                this.searchForm.examId = null
                this.setSelNull()
                this.examChange()

                // 添加学年学期等新的参数(只修改考试列表)
                let search = { licenceId: this.userInfo.licenceId, isAb: '1', schoolId: this.searchFormRole.schoolId, teacherId: null, semester: this.searchFormRole.semester,courseId: this.searchFormRole.courseId};
                let role = this.userInfo.role;
                // if(role == "sclAdmin") search["schoolId"] = this.userInfo.schoolId;
                if(role == "teacher") {
                    // search["schoolId"] = this.userInfo.schoolId;
                    search["teacherId"] = this.userInfo.id;
                }
                let param = { controllerName: 'exam', methodName: '/examList', pageNo: 1, pageSize: 50, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.examList = data.result;
                       
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 筛选缺考/作弊
            filterStudents(){
                let checked = this.filter
                // 切换时清空图片
                if(checked){
                    let search = { 
                        licenceId: this.searchForm.licenceId, 
                        examId: mUtils.searchText(this.searchForm.examId),
                        searchText: mUtils.searchText(this.searchForm.searchText), 
                        groupBy: 'sf.student_id',
                        hardId: mUtils.searchText(this.searchForm.hardClassId)
                    };
                    let param = { controllerName: 'scan/scanPreResult', methodName: '/selectPreBySpecial', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                    return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadRightList", data)
                    if (data.code == 0) {
                        this.rightList = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                        this.totalNums = data.totalCount 
                    }
                    this.setSelNull()
                    this.loading = false;
                    }).catch((error) => {
                    console.log("error", error)
                    });
                }else{
                    this.setSelNull()
                    this.loadRightList()
                }
            
            },
            // 行政班 和教学班整合查询
            searchHardOrTeachingClass(){
                this.selectIsLoading = true;
                let search = { examId: this.searchForm.examId};
                let param = { controllerName: 'examTeachingClass', methodName: '/getHardOrTeachingListByResult',  param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (code == 0) {
                        this.hardAndTeachingClassList = data;
                    }
                    this.selectIsLoading = false;
                }).catch((error) => {
                    console.log(error)
                    this.selectIsLoading = false;
                });
            },
            // 统计作弊缺考人数
            loadCount(){
                let search = { examId: mUtils.searchText(this.searchForm.examId),licenceId: this.searchForm.licenceId};
                let param = { controllerName: 'scan/scanPreResult', methodName: '/countResult', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    this.specialNums = data.specialNums
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            // 成绩筛选
            scoreSearch(){
                if(this.searchForm.examId == null || this.searchForm.examId == '' || this.searchForm.examId == undefined ) return
                // 取消自动重算
                if(!this.filterScore) 
                {
                    this.searchRightList()
                    return
                }
                this.scoreSearchDialogVisible = true
            },
            scoreSearchSubmit(){
                // debugger
                this.searchRightList()
                this.scoreSearchDialogVisible = false
            },
            scoreSearchCancel(){
                this.filterScore = false
                this.searchRightList()
                this.scoreSearchDialogVisible = false
            },
            // 加载当前关联答题卡类型
            getScantronInfo(){
                let param = { controllerName: 'exam/scantron', methodName: '/getSheetByExamId', param: {examId: mUtils.searchText(this.searchForm.examId),}};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    // this.scantronInfo = data
                    this.percentType = mUtils.getPercentType(data.updateTime)

                });
            },


        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .scanPreResult{
        // padding: 10px;
        .search_container{

        }
        .error {
            color: red;
        }
        .collapse-title{
            font-size: 16px;
            font-weight: bold;
            margin-left: 20px;
        }
        .left-part {
            // padding: 10px;
            // border: 1px solid rgba(203, 202, 202, 0.71);
            // border-bottom-left-radius: 10px;
            // border-bottom-right-radius: 10px;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;
            overflow: auto;
            .data-row{
                margin-bottom: 10px;
                text-align: left;
            }
            .page-row{
                margin-top: 10px;
                line-height: 30px;
                text-align: center;
            }
        }
        .right-part {
            // padding: 10px;
            // border: 1px solid rgba(203, 202, 202, 0.71);
            // border-bottom-left-radius: 10px;
            // border-bottom-right-radius: 10px;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;

            .data-row{
                margin-bottom: 10px;
            }
            .student-no-lost {
                text-align: left;
            }
        }
        .btnRight{
            float: right;
            margin-right: 0px !important;
        }
        .searchArea{
            background:rgba(255,255,255,1);
            border-radius:2px;
            padding: 18px 18px 0;
        }
        .table_container{
            padding: 10px;
            background: #fff;
            border-radius: 2px;
        }
        .el-dialog--small{
           width: 600px !important;
        }
        .pagination{
            text-align: left;
            margin-top: 10px;
        }
    }

</style>


